"use strict";
/*

 try{ this.postAjax("/src/php/sistema/http/obj/Busca/ajax-sug-listar.php", params);
 } catch (ex){ Util.alert(ex); }
 */

var request = require("superagent");
var config = require("app/util/config/config");

var sessionId = (typeof window !== "undefined" && window.getCookie)?window.getCookie("PHPSESSID"):null;
var jwt = (typeof window !== "undefined" && window.getCookie)?window.getCookie("AGENDOR"):null;
var webURL = config.app.webURL;

module.exports.searchEntity = function searchEntity(params, cb) {
  get("/src/php/sistema/http/obj/Busca/ajax-sug-listar-json.php", params, cb);
};

function getURL(endpoint){
  return webURL+endpoint;
}

var get = module.exports.get = function get(endpoint, params, cbf){
  exec("get", endpoint, params, cbf);
};

var post = module.exports.post = function post(endpoint, params, cbf){
  exec("post", endpoint, params, cbf);
};

var exec = module.exports.exec = function exec(method, endpoint, params, cbf){
  var sendParamsMethod = (method=="get")?"query":"send";
  var callAPI = request[method](getURL(endpoint))
    .set("SESSION_ID", sessionId)
    .set("AGENDOR", jwt)
    .set("Content-Type", "application/x-www-form-urlencoded");

  callAPI[sendParamsMethod](params)
    .end(function(err, response) {
      if (err) {
        console.error(endpoint, status, err.stack);
      } else {
        if (cbf) {
          cbf(getText(response), response);
        }
      }
    });
};

function getText(response) {
  var text = null;
  try {
    text = JSON.parse(response.text);
  } catch (error) {
    text = response.text;
  }
  return text;
}



// WEBPACK FOOTER //
// ./app/util/api/php-api.js